<template>
  <vs-popup
    class="modalOptions"
    :active="isVisible"
    @close="closeModal"
    :title="title"
    id="modal-painel-comercial"
  >
    <div class="v2_company_dialog px-4" v-if="isAnnualPodium">
      <h2 class="v2_company_dialog_title">
        Selecione a prioridade de ordenação desejado:
      </h2>

      <ul class="v2_company_dialog_list">
        <li
          class="v2_company_dialog_list_item"
          :key="criteriaOption.id"
          v-for="criteriaOption of rankingCriteriaOptions"
        >
          <input
            type="radio"
            :id="criteriaOption.id"
            name="RankingCriteria"
            v-model="selectedRankingCriteria"
            :value="criteriaOption.type"
            :checked="criteriaOption.type === selectedRankingCriteria"
          />
          <label class="text-sm" :for="criteriaOption.id">{{
            criteriaOption.label
          }}</label>
        </li>
      </ul>
    </div>
    <div v-if="modalData.length > 0" class="v2_company_dialog px-4">
      <h2 class="v2_company_dialog_title">{{ subtitle }}</h2>

      <ul class="v2_company_dialog_list">
        <li
          class="v2_company_dialog_list_item"
          :key="division.idDivisao"
          v-for="division of modalData"
        >
          <input
            type="radio"
            :id="division.idDivisao"
            name="Division"
            v-model="selectedDivisionName"
            :value="division.nomeDivisao"
            @change="selectDivision"
            :checked="division.nomeDivisao === selectedDivisionName"
          />
          <label class="text-sm" :for="division.idDivisao">{{
            division.nomeDivisao
          }}</label>
        </li>
      </ul>
      <div v-if="selectedDivisionName">
        <hr class="mb-4" />
        <h2 class="v2_company_dialog_title">
          Selecione a(s) empresa(s) que deseja visualizar
        </h2>
        <ul class="my-4">
          <li v-for="(company, index) in companies" :key="index">
            <vs-checkbox
              :color="primaryColor"
              class="my-3"
              v-model="selectedCompanies"
              :vs-value="company.id_empresa"
              >{{ company.nome }} - {{ company.id_empresa }}
            </vs-checkbox>
          </li>
        </ul>
      </div>
      <div class="flex justify-end">
        <vs-button class="w-auto" @click="selectCompany" :color="primaryColor"
          >Aplicar</vs-button
        >
      </div>
    </div>
    <div v-else class="v2_company_dialog px-4">
      <h2 class="v2_company_dialog_title">
        Não há divisões que podem ser visualizadas por este setor.
      </h2>
    </div>
  </vs-popup>
</template>

<script>
import { CRITERIA_OPTIONS } from '../utils';

export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    modalData: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    currentCompany: {
      type: Number,
    },
    isAnnualPodium: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedDivisionName: null,
      selectedCompanies: [],
      primaryColor: '#114880',

      selectedRankingCriteria: 'TotalVendas',
    };
  },
  watch: {
    currentCompany(value) {
      if (value) {
        this.selectedCompanies = [value];
      }
    },
  },
  computed: {
    rankingCriteriaOptions() {
      return CRITERIA_OPTIONS;
    },
  },
  methods: {
    openActions(event) {
      this.$refs.popover.openPopover(event);
    },

    openChangeDivisionDialog() {
      this.$refs.dialog.openDialog();
    },

    selectDivision() {
      this.companies = this.$store.state.listEmpresa;
    },
    selectCompany() {
      if (
        !this.selectedDivisionName ||
        !this.selectedCompanies.length ||
        !this.selectedRankingCriteria
      ) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'É necessário selecionar uma divisão e pelo menos uma empresa!',
          color: 'warning',
        });
        return;
      }
      const config = {
        divisionName: this.selectedDivisionName,
        companiesIds: this.selectedCompanies,
        rankingCriteria: this.selectedRankingCriteria,
      };
      this.$emit('exhibitionConfig', config);
      this.closeModal();
    },
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style>
.modalOptions .vs-popup--header {
  display: flex !important;
  background-color: #e7f4fb;
  padding: 10px 24px 10px 16px;
  align-items: end;
}

.modalOptions .vs-popup--header .vs-icon {
  background: #114880 !important;
  border-radius: 50%;
  color: white;
  font-size: 12px;
  padding: 5px;
}
</style>
